import { Box, IconButton, Modal, TextField, Typography } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close';

const ACCENT_BLUE = '#22638f';
const ACCENT_ORANGE = '#d96c3c';
const TEXT_MUTED = '#93a0b5';
const TEXT_BODY = '#3b4a63';
const BORDER = '#eef2f8';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 360,
  bgcolor: '#fff',
  border: `1px solid ${BORDER}`,
  boxShadow: '0 8px 30px rgba(12, 61, 110, 0.15)',
  borderRadius: '16px',
  p: 3.5,
};

const fieldSx = {
  '& .MuiOutlinedInput-root': {
    borderRadius: '10px',
    backgroundColor: '#fff',
  },
  '& .MuiOutlinedInput-notchedOutline': { borderColor: BORDER },
  '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: ACCENT_BLUE },
  '& .Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: `${ACCENT_BLUE} !important` },
};

function WeightAndMoisture({ open, setOpen, weight, setWeight, moisture, setMoisture }) {

  const handleClose = () => {
    setMoisture("")
    setWeight("")
  };

  return (
    <Modal open={open} onClose={handleClose}>
      <Box sx={style}>
        <IconButton
          aria-label="close"
          onClick={() => setOpen(false)}
          sx={{
            position: 'absolute',
            top: 10,
            right: 10,
            color: TEXT_MUTED,
          }}
        >
          <CloseIcon fontSize="small" />
        </IconButton>

        <Typography sx={{ fontSize: 16, fontWeight: 700, color: TEXT_BODY, mb: 3 }}>
          Enter Details
        </Typography>

        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2.5 }}>
          <TextField
            required
            fullWidth
            size="small"
            label="Enter Weight (gm)"
            value={weight || ''}
            onChange={(e) => setWeight(e.target.value)}
            sx={fieldSx}
          />
          <TextField
            required
            fullWidth
            size="small"
            label="Enter Moisture (%)"
            value={moisture || ''}
            onChange={(e) => setMoisture(e.target.value)}
            sx={fieldSx}
          />
        </Box>

        <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1.5, mt: 4 }}>
          <button
            onClick={handleClose}
            style={{
              padding: '9px 20px',
              borderRadius: 10,
              border: `1px solid ${BORDER}`,
              backgroundColor: '#fff',
              color: TEXT_BODY,
              fontSize: 13.5,
              fontWeight: 600,
              cursor: 'pointer',
            }}
          >
            Reset
          </button>
          <button
            onClick={() => setOpen(false)}
            style={{
              padding: '9px 20px',
              borderRadius: 10,
              border: 'none',
              backgroundColor: ACCENT_ORANGE,
              color: '#fff',
              fontSize: 13.5,
              fontWeight: 600,
              cursor: 'pointer',
            }}
          >
            Proceed
          </button>
        </Box>
      </Box>
    </Modal>
  )
}

export default WeightAndMoisture